import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, favoriteControl = null } = props;
  const images = listing.images;
  const imageVariants = ['square-small2x' ,'scaled-medium' ];
  // 'square-small2x'
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        favoriteControl={favoriteControl}
      />
    </section>
  );
};

export default SectionGallery;
